import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TicketModel, ITicket, TicketByIDModel } from '@ciptech/classes/ws-ticket';
import { map } from 'rxjs/operators';

@Injectable()
export class WsTicketService {
    private endpoint = `/api/WsTickets`;

    constructor(private http: HttpClient) { }

    insert(ticket: any, files?: any[]): Observable<{ id: number, roles: any[] }> {
        ticket.IdTicket = ticket.IdTicket || 0;
        ticket.TicketIncidencia?.forEach((x: any, i: number) => x.Item = i + 1);

        const formData = new FormData();
        formData.append('ticket', JSON.stringify(ticket));
        //formData.append('Departamento', ticket.Departamento);
        files.forEach((file, index) => formData.append(`file_${index}`, file));
        // formData.append('archivo', ticket.Archivo);

        return this.http.post<{ id: number, roles: any[] }>(`${this.endpoint}`, formData, { headers: { context: 'body' } });
    }

    getByPeriodo(anyo: number, ctx?: string): Observable<TicketModel[]> {
        return this.http.get<ITicket[]>(`${this.endpoint}?anyo=${anyo}`, { headers: { context: ctx || 'body' } })
            .pipe(
                map(res => res.map(item => new TicketModel(item)))
            );
    }

    getByID(id: number, ctx?: string): Observable<TicketByIDModel> {
        return this.http.get<any>(`${this.endpoint}/GetByID?id=${id}`, { headers: { context: ctx || 'body' } })
            .pipe(
                map(res => res && new TicketByIDModel(res))
            );
    }

    getRequerimientos(id: number): Observable<any[]> {
        return this.http.get<any[]>(`${this.endpoint}/requerimientos?IdTicket=${id}`, { headers: { context: '.load-rrss' } });
    }

    calificar(ticket: any, ctx?: string): Observable<number> {        
        return this.http.post<number>(`${this.endpoint}/calificar`, ticket, { headers: { context: ctx || 'body' } });
    }
}